const chains = [];
chains.push({ _operation: 'createUserRelationship', api: '/user-relationship', defaultData: null, httpVerb: 'post' });
chains.push({ _operation: 'deleteUserRelationshipById', api: '/user-relationship/:objectId', defaultData: null, httpVerb: 'delete' });
chains.push({ _operation: 'getUserRelationships', api: '/user-relationships', defaultData: [], httpVerb: 'get' });
export default chains;
